import React, { useState, useRef, useEffect } from "react";
import { MapBoxWindow } from "./_heat-map.styled";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import "mapbox-gl/dist/mapbox-gl.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

mapboxgl.accessToken =
  process.env.REACT_APP_MAPBOX_PUBLIC_KEY
const HeatMap = (props) => {
  const { selectedCampaignData, campaignId, resetMapStyle, geoJsonLink, loading } = props || [];

  const mapContainer = useRef(null);
  const map = useRef(null);
  const [initialCenter] = useState({
    lng: 55.2708,
    lat: 25.2048,
  });
  const [zoom] = useState(12);

  useEffect(() => {
    initMapbox();
  }, []); // Initialize map on component mount or when `resetMapStyle` changes

  useEffect(() => {
    removeAllLayers()
  }, [campaignId])


  useEffect(() => {
    if (!map.current) return; // Wait for the map to be initialized

    const addMapLayers = () => {
      if (!map.current) return;

      // Check if source already exists
      let source = map.current.getSource("heatmap-source");
      if (source) {
        // If it exists, just update the data
        source.setData(geoJsonLink);
      } else {
        // Otherwise, add it
        map.current.addSource("heatmap-source", {
          type: "geojson",
          data: geoJsonLink,
        });
      }

      // Check if layer already exists
      if (!map.current.getLayer("heatmap-layer-heat")) {
        map.current.addLayer({
          id: "heatmap-layer-heat",
          type: "heatmap",
          source: "heatmap-source",
          paint: {
            "heatmap-weight": 1,
            "heatmap-intensity": 1,
            "heatmap-color": [
              "interpolate",
              ["exponential", 1],
              ["heatmap-density"],
              0,
              "hsla(0, 0%, 0%, 0)",
              0.33,
              "hsl(213, 100%, 49%)",
              0.67,
              "hsl(107, 100%, 46%)",
              1,
              "hsl(16, 99%, 38%)",
            ],
            "heatmap-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              3.5,
              5,
              4.2,
              10,
              5.25,
              22,
              7,
            ],
            "heatmap-opacity": 0.8,
          },
        });
      }
    };

    if (geoJsonLink) {
      if (map.current.isStyleLoaded()) {
        addMapLayers();
        setTimeout(() => map.current && map.current.resize(), 100);
      } else {
        const onStyleData = () => {
          addMapLayers();
          setTimeout(() => map.current && map.current.resize(), 100);
        };
        map.current.once("styledata", onStyleData);
      }
    }
  }, [geoJsonLink]); // Reload map layers when `geoJsonLink` changes


  const removeAllLayers = () => {
    if (map.current.getLayer('heatmap-layer-heat')) {
      map.current.removeLayer('heatmap-layer-heat');
    }
    // if (map.current.getLayer('earthquakes-point')) {
    //   map.current.removeLayer('earthquakes-point');
    // }
    if (map.current.getSource('heatmap-source')) {
      map.current.removeSource('heatmap-source');
    }
  }

  const initMapbox = () => {
    if (!map.current) {
      // Initialize map only once
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: resetMapStyle,
        center: initialCenter, // Starting position [lng, lat]
        zoom: zoom,
      });

      map.current.addControl(new mapboxgl.NavigationControl(), "top-right");
      map.current.addControl(new mapboxgl.FullscreenControl(), "top-right");
    }
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      // Perform resize only if the map is initialized and has a canvas
      if (map.current && map.current.getCanvas()) {
        try {
          map.current.resize();
        } catch (e) {
          console.error("Mapbox resize failed", e);
        }
      }
    });

    if (mapContainer.current) {
      resizeObserver.observe(mapContainer.current);
    }

    return () => {
      resizeObserver.disconnect();
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, []);

  return (
    <MapBoxWindow style={{ position: "relative" }}>
      <div
        ref={mapContainer}
        className="heat-map-container"
        style={{ height: `100%`, width: `100%`, position: "relative", overflow: "hidden" }}
      />
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1,
          }}
        >
          <Spin tip="Loading" size="large">

          </Spin>
        </div>
      )}
    </MapBoxWindow>
  );
};

export default HeatMap;
